import { render, staticRenderFns } from "./ClienteGridDemonstracao.vue?vue&type=template&id=04ef3968&scoped=true&"
import script from "./ClienteGridDemonstracao.vue?vue&type=script&lang=js&"
export * from "./ClienteGridDemonstracao.vue?vue&type=script&lang=js&"
import style0 from "./ClienteGridDemonstracao.vue?vue&type=style&index=0&id=04ef3968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef3968",
  null
  
)

export default component.exports